module.exports = __webpack_public_path__ + "static/media/ts11tj0.31f216f2.png";